import { useContext, useEffect, useState } from 'react';
// import { useNavigate } from 'react-router-dom';
import { axiosWrapper } from './axios';

import { AuthContext } from '../context/AuthProvider';
import { useShowSettings } from './useShowSettings';
// import DemoAskInfoPage from '../modules/auth/pages/DemoAskInfoPage';

export const useOnAppInit = () => {
  const user = useContext(AuthContext);
  // const navigate = useNavigate();
  const [isRedirected, setIsRedirected] = useState(false);
  const showSettings = useShowSettings();
  // const [hasAskedDemoInfo, setHasAskedDemoInfo] = useState(false);

  useEffect(() => {
    // if (user) {
    //   if (
    //     user.demos_to_ask &&
    //     user.demos_to_ask.length > 0 &&
    //     !hasAskedDemoInfo
    //   ) {
    //     const URL = '/api/v1/records/demo/asked/';
    //     axiosWrapper<any>(URL, 'patch', {})
    //       .then((res) => {
    //         if (res.data.ok) {
    //           // setHasAskedDemoInfo(true);
    //           // navigate(DemoAskInfoPage.getRoute())
    //         } else {
    //           alert(res.data.error);
    //         }
    //       })
    //       .catch((err) => console.error(err));
    //   }
    // }
    if (!showSettings) {
      return;
    }
    if (user) {
      if (user.has_wrong_email || user.has_wrong_username) {
        setIsRedirected(true);
        (window as any).location = '/settings';
      }
      if (user.show_intro && !isRedirected) {
        const URL = `/api/v1/users/users/${user.pk}/update/`;
        axiosWrapper<any>(URL, 'patch', { show_intro: false })
          .then((res) => {
            if (res.data.ok) {
              setIsRedirected(true);
              (window as any).location = '/settings';
            } else {
              alert(res.data.error);
            }
          })
          .catch((err) => console.error(err));
      }
    }
  }, [user, showSettings]);
};
